import { getHash } from '@/helpers/number'
import { observeIntersection } from '@/helpers/intersection-observer'
const handlers = {}

export function requestAnimationFrameAsync() {
  return new Promise(resolve => requestAnimationFrame(resolve))
}

export function listenToTransitionEnd(element, animatedProps, callback, options = {}) {
  if (!element.__uniqueHashId__) element.__uniqueHashId__ = getHash()
  if (handlers[element.__uniqueHashId__]) return

  handlers[element.__uniqueHashId__] = e => {
    const isAnimatedProperty = animatedProps.some(prop => e.propertyName === prop)

    if (e.target === element && isAnimatedProperty) {
      if (options.once) {
        element.removeEventListener('transitionend', handlers[element.__uniqueHashId__])
        delete handlers[element.__uniqueHashId__]
      }
      callback()
    }
  }
  element.addEventListener('transitionend', handlers[element.__uniqueHashId__])
}

export function listenToTransitionEndOnce(element, animatedProps, callback) {
  listenToTransitionEnd(element, animatedProps, callback, { once: true })
}

export async function expandElement(el, isOpen) {
  el.style.height = `${el.scrollHeight}px`

  if (!isOpen) {
    await requestAnimationFrameAsync()
    el.style.height = ''
  }
}

export function shakeElement(element) {
  if (element.__isShaking__) return

  element.__isShaking__ = true
  element.classList.add('shake-animation')

  const onAnimationEnd = e => {
    if (e.animationName === 'shake') {
      element.removeEventListener('animationend', onAnimationEnd)
      element.classList.remove('shake-animation')
      element.__isShaking__ = false
    }
  }
  element.addEventListener('animationend', onAnimationEnd)
}

export function getAnimationProgress({
  progress,
  start,
  pause = 1,
  animate,
  easing = v => v,
  isAnimatingIn = true,
  isAnimatingOut = true,
}) {
  const end = start + animate + pause + animate
  return easing(
    (isAnimatingIn && progress < end - animate) || !isAnimatingOut
      ? getProgress(progress, start, start + animate)
      : getProgress(progress, end, end - animate)
  )
}

export function getProgress(position, start, end) {
  return Math.max(Math.min((position - start) / (end - start), 1), 0)
}

export const introAnimation = (selectors = []) => {
  const elements = document.querySelectorAll(selectors.join(','))
  if (!elements.length) return

  // hoisting to be used on observer callbacks
  const introObservers = []
  const introAnimationHandler = ({ target: element }) => {
    // play intro
    element.classList.add('intro-animation--visible')
    // remove observer
    if (introObservers[element.dataset.intro]) {
      introObservers[element.dataset.intro].disconnect()
    }
  }

  elements.forEach((element, index) => {
    // add animation class
    element.classList.add('intro-animation')
    // only connect an observer to parents
    if (element.parentNode.closest('.intro-animation')) return
    // observer index
    element.dataset.intro = index
    // set observer
    introObservers.push(observeIntersection(element, introAnimationHandler, { threshold: 0.1 }))
  })
}
